<template>
   <div>
    <section-definition :title="page.title" :breadcrumbs="breadcrumbs"></section-definition>
    <v-container fluid grid-list-xl page>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <section-header v-text="page.headline"></section-header>
          <div class="subheading justify" v-html="page.description"></div>
          <div class="my-5"></div>
        </v-flex>
      </v-layout>
      <!-- Your contet -->
    </v-container>
    <v-container fluid grid-list-xl page>

      <v-layout row wrap>

   <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar.."
            single-line
      ></v-text-field>
    </v-card-title>
  <v-data-table
    :headers="headers"
    :items="payments"
     :search="search"
     :loading="isLoading"
    rows-per-page-text="Filas por página"
    :rows-per-page-items="[15,30,50,{text:'todas', value:-1}]"
      
    class="elevation-1"
  >
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

    <template slot="items" slot-scope="props">
      <td>{{ props.item.useralias }}</td>
      <td>{{ props.item.idrent }}</td>
       <td class="text-xs-right">{{ props.item.paymentamount }}</td>
     <td class="text-xs-right">{{ props.item.amountpayed }}</td>
      <td :class="props.item.stateclass">{{ props.item.idpaymentstatus }}</td>
      <td class="text-xs-right">{{ props.item.machinename }}</td>
      <td class="text-xs-right">{{ props.item.paymenttypelabel }}</td>
      <td class="text-xs-right">{{ props.item.transactiondate }}</td>
      <td class="text-xs-right">{{ props.item.paymentdate }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>

        </td>      
    </template>
        <template slot="pageText" slot-scope="props">
      Filas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
    </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
        La búsqueda de  "{{ search }}" no ha encontrado resultados.
      </v-alert>
  </v-data-table>
   </v-card>

      </v-layout>

      <v-dialog v-model="isChangePaymentDialog" max-width="500px">

      <v-card>
          <v-card-title>
            <span class="headline">Confirmar pago</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.amountpayed" label="Importe pagado"></v-text-field>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
           <v-btn color="red darken-1"  @click.native="isChangePaymentDialog = false">Cancelar</v-btn>
           <v-btn color="blue darken-1" @click.native="confirmSave">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

   <v-snackbar
      v-model="snackresult"
      :color="snackcolor"
      :timeout="6000"
      top=true
    >
      {{ snacktext }}
      <v-btn
        dark
        flat
        @click="snackresult = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>

    </v-container>
  </div>
</template>

<script>
/*
amountpayed: 900
idpaymentstatus: 2
idrent: 488
machinename: "Ter"
owneralias: "Marta12"
paymentamount: 900
paymentdata: "959999/018687897529827156149505050702"
paymentdate: "Mon, 05 Aug 2019 00:00:00 GMT"
paymenttype: 1
rentfrom: "Tue, 20 Aug 2019 00:00:00 GMT"
rentto: "Wed, 28 Aug 2019 00:00:00 GMT"
transactiondate: "Fri, 19 Jul 2019 11:48:26 GMT"
useralias: "Marta12"
*/
import { required, email, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import PlainTableOrder from "@/components/Widgets/list/PlainTableOrder";
import { RepositoryFactory } from "./../../repositories/RepositoryFactory";
const PaymentsRepository = RepositoryFactory.get("payments");

export default {
  mixins: [validationMixin],

  data() {
    return {
      search: "",
      headers: [
        { text: "Usuario", value: "useralias" },
        { text: "ID alquiler", value: "idrent" },
        {
          text: "Importe (€)",
          align: "left",
          value: "paymentamount"
        },
        {
          text: "Pagado(€)",
          align: "left",
          value: "amountpayed"
        },
        { text: "Estado", value: "idpaymentstatus" },
        { text: "Equipo ", value: "machinename" },
        { text: "Tipo de pago", value: "paymenttype" },
        { text: "Fecha transac. ", value: "transactiondate" },
        { text: "Fecha pago ", value: "paymentdate" },
        { text: "Acciones ", value: "", sortable: false }
      ],
      payments: [],
      isLoading: false,
      isChangePaymentDialog: false,
      editedIndex: -1,
      editedItem: {},
      snackbar: false,
      page: {
        title: "Pagos",
        headline: "Listado de Pagos",
        description: `Pagos de alquileres.`
      },
      breadcrumbs: [
        {
          text: "Admin",
          disabled: false
        },
        {
          text: "Paginas",
          disabled: false
        },
        {
          text: "Pagos",
          disabled: false
        }
      ],
      snackresult: false,
      snacktext: "",
      snackcolor: "success"
    };
  },
  components: {
    PlainTableOrder
  },
  mounted: function() {
    this.loadData();
  },
  methods: {
    loadData() {
      const self = this;
      let url = process.env.VUE_APP_BASE_URI + "/getpaymentslist";
      self.isLoading = true;
      self.$http.get(url).then(
        function(success) {
          var paymentstemp = success.data.paymentslist;
          self._.forEach(paymentstemp, function(expense, index) {
            paymentstemp[index].transactiondate = self
              .moment(expense.transactiondate)
              .format("DD-MM-YYYY")
              .split("T")[0];
            paymentstemp[index].paymentdate = self
              .moment(expense.paymentdate)
              .format("DD-MM-YYYY")
              .split("T")[0];
            if (expense.paymenttype === 1) {
              paymentstemp[index].paymenttypelabel = "Tarjeta";
            }
            if (expense.paymenttype === 2) {
              paymentstemp[index].paymenttypelabel = "Adeudo ";
            }
            if (expense.paymenttype === 3) {
              paymentstemp[index].paymenttypelabel = "Transferencia";
            }

            if (expense.idpaymentstatus === 1) {
              paymentstemp[index].stateclass = "state1";
              paymentstemp[index].idpaymentstatus = "PENDIENTE";
            }
            if (expense.idpaymentstatus === 2) {
              paymentstemp[index].stateclass = "state2";
              paymentstemp[index].idpaymentstatus = "PAGADO";
            }
            if (expense.idpaymentstatus === 3) {
              paymentstemp[index].stateclass = "state3";
              paymentstemp[index].idpaymentstatus = "RECHAZADO";
            }
          });
          self.payments = paymentstemp;
          self.isLoading = false;
        },
        function(error) {
          self.isLoading = false;
          self.snacktext = "Error al obtener lista de transportes";
          self.snackcolor = "error";
          self.snackresult = true;
        }
      );
      /*     const _this=this;
      
        const { data } =  PaymentsRepository.listPayments().then(
                function(success) {
                    _this.$store.commit('', false)
                    //this.$router.push({path: '/myMachines'})
                    //his.posts = data;
                    _this.$router.push({
                        name: "dashboard/Dashboardv1"
                    });

                }).catch(function(error) {
                    _this.loginError = true
                }
            )
*/
    },

    editItem(item) {
      this.editedIndex = this.payments.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.amountpayed = this.editedItem.paymentamount;
      this.isChangePaymentDialog = true;
    },

    confirmSave() {
      let item = this.editedItem;
      if (true) {
        const self = this;
        let url = process.env.VUE_APP_BASE_URI + "/newpayment/" + item.rentuuid;
        item.amountpayed = item.paymentamount;
        let paydata = {
          idpayment: item.idpayment,
          idrent: item.idrent,
          paymentamount: item.amountpayed
        };
        self.$http.post(url, paydata).then(
          function(success) {
            self.isChangePaymentDialog = false;
            self.snacktext = "El estado del pago  se ha modificado ";
            self.snackcolor = "success";
            self.snackresult = true;
          },
          function(error) {
            self.isSaveUser = false;

            self.snacktext = "Error. Los datos  no se han modificado";
            self.snackcolor = "red";
            self.snackresult = true;
          }
        );
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
  .section-def
    margin-bottom: 50px
  .toobar-extension
    margin-left: 5px !important
  .breadcrumb-section
    margin-left: -25px !important
  .action-btn
    margin-left: 5px !important

  .state1{
    background-color :blue;

    color : #ffffff;

  }

  .state2{
    background-color :green;
    color : #ffffff;
    
  }

  .state3{
    background-color :red;
    color : #ffffff;
    
  }

</style>
